import { useState } from 'react'

const usePagination = (perPage: number, total: number) => {
  const remainder = total % perPage
  const pages = (total - remainder) / perPage + (remainder ? 1 : 0)
  const [currentPage, setCurrentPage] = useState(1)

  const nextPage = () => {
    if (currentPage < pages) {
      setCurrentPage(currentPage + 1)
    }
  }
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  return { pages, currentPage, nextPage, prevPage }
}

export default usePagination
